<template>
  <div>
    <div class="smart-input smart-input_array">
      <div v-if="caption" class="smart-input__name">
        {{ caption }}
      </div>

      <div v-for="(subValue, subValueIndex) in newValue" :key="subValueIndex" class="smart-input__wrapper">
        <div class="smart-input__input">
          <input
            :id="`smart-input-field-${subValueIndex}`"
            ref="elementForFocus"
            v-model="newValue[subValueIndex]"
            :disabled="disabled"
            :placeholder="placeholder"
            class="smart-input__field"
            type="text"
          >

          <CamsButton icon-type="only" type="button" @click="deleteValue(subValueIndex)">
            <img :alt="$t('deleteRow')" src="./img/delete-list-item.svg">
          </CamsButton>
        </div>

        <label
          v-if="subValueErrors[subValueIndex]"
          :for="`smart-input-field-${subValueIndex}`"
          class="smart-input__error-message"
        >
          {{ subValueErrors[subValueIndex] }}
        </label>
      </div>

      <CamsButton icon-type="float" :title="$t('addRowTitle')" type="button" @click="addNewValue()">
        <img :alt="$t('addRow')" src="./img/add-list-item.svg">
        {{ $t('addRow') }}
      </CamsButton>

      <div v-if="commonError" class="smart-input__error-message">
        {{ commonError }}
      </div>
    </div>
  </div>
</template>


<script>
/**
 * Компонент для нескольких полей ввода с возможностью отображения ошибок.
 * Позволяет редактировать списковые данные, в которых нужно проверять каждое значение в отдельности.
 */
export default {
  props: {
    /**
     * Значение, которое надо передавать через v-model.
     */
    value: {
      type: Array,
      default: () => ([]),
    },
    /**
     * Заголовок для всего блока.
     */
    caption: {
      type: String,
      default: "",
    },
    /**
     * Содержимое для placeholder в каждый input-элемент.
     */
    placeholder: {
      type: String,
      default: "",
    },
    /**
     * Текст ошибок для каждого поля.
     */
    error: {
      type: [String, Array],
      default: () => ([]),
    },
    /**
     * Опция для отключения возможности ввода в каждое поле.
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newValue: this.value ? [...this.value] : [],
    };
  },
  computed: {
    /**
     * @return {Array<String>} Массив строк с текстами ошибок для каждого отдельного значения массива.
     */
    subValueErrors() {
      return Array.isArray(this.error) ? this.error : [];
    },
    /**
     * @return {String} Строка с общей ошибкой для всего элемента.
     */
    commonError() {
      return _.isString(this.error) ? this.error : "";
    },
  },
  watch: {
    /**
     * @return {String} Наблюдение за оригинальным значением для его синхронизации со внутренним значением компонента и отправкой события `@change`.
     */
    value() {
      const newValue = [...this.value];
      if (_.isEqual(newValue, this.newValue)) {
        return;
      }
      this.newValue = newValue;
      this.$emit("change", newValue)
    },
    /**
     * Наблюдение за каждым значением списка и передача измененных значений в родительский компонент по событию `@input`.
     * @event input
     */

    newValue: {
      handler() {
        if (_.isEqual(this.value, this.newValue)) {
          return;
        }
        /**
         * Срабатывает при изменении значения элемента списка.
         * @event input
         */
        this.$emit("input", this.newValue);
      },
      deep: true,
    },
  },
  methods: {
    /**
     * Добавление строчки с пустым значением.
     */
    addNewValue() {
      this.newValue.push("");
    },
    /**
     * Удаление строчки со значением и аналогичного элемента в списке ошибок (если это список ошибок).
     * @param {Number} subValueIndex
     */
    deleteValue(subValueIndex) {
      this.newValue.splice(subValueIndex, 1);
      Array.isArray(this.error) && this.error.splice(subValueIndex, 1);
    },
  },
};
</script>

<style lang="scss">
@import "./scss/style.scss";
</style>
